const supportUrl =
  'https://api.whatsapp.com/send/?phone=552125036879&text&app_absent=0';

export { supportUrl };
